import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" I am a Systems Administrator and Software Developer. Currently working on my Computer Science degree! ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" I also own two companies, love the gym, ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" cars and to travel. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("My Links")
const _hoisted_7 = {
  class: "ion-padding",
  slot: "content"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", { href: "https://www.linkedin.com/in/ceotrammell/" }, "LinkedIn", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", { href: "https://github.com/ceotrammell" }, "Github", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", { href: "https://ceotrammell.hashnode.dev/" }, "Hashnode", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", { href: "https://twitter.com/ceotrammell" }, "Twitter", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Software Skills")
const _hoisted_17 = {
  class: "ion-padding",
  slot: "content"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Tools Used")
const _hoisted_19 = {
  class: "ion-padding",
  slot: "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_card, { class: "home-header-sub-ion-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_card_content, { class: "aboutmecomponent-sub-ion-card-content" }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_card_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_accordion_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_accordion, { value: "first" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      lines: "none",
                      slot: "header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_ion_list, {
                        class: "home-header-sub-ion-list",
                        lines: "none"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.logoLinkedin }, null, 8, ["icon"]),
                              _hoisted_8,
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _hoisted_9
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.logoGithub }, null, 8, ["icon"]),
                              _hoisted_10,
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.book }, null, 8, ["icon"]),
                              _hoisted_12,
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.logoTwitter }, null, 8, ["icon"]),
                              _hoisted_14,
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _hoisted_15
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_card_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_accordion_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_accordion, { value: "first" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      lines: "none",
                      slot: "header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_apexchart, {
                          height: "600,",
                          type: "bar",
                          options: _ctx.mySkillsChartOptions,
                          series: _ctx.mySkillsChartseries
                        }, null, 8, ["options", "series"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_card_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_accordion_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_accordion, { value: "first" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      lines: "none",
                      slot: "header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_apexchart, {
                          height: "600,",
                          type: "bar",
                          options: _ctx.myToolsChartOptions,
                          series: _ctx.myToolsChartseries
                        }, null, 8, ["options", "series"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}